import React from 'react';
import { Paper, Typography, Alert, Stack } from '@mui/material';

const severityMap = {
  critical: 'error',
  warning: 'warning',
  info: 'info',
};

const AlertsPanel = ({ alerts, translate }) => {
  const rows = Array.isArray(alerts) ? alerts : [];

  if (rows.length === 0) {
    return null;
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 2,
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
        {translate('home.dashboard.alerts')}
      </Typography>
      <Stack spacing={1}>
        {rows.map((a, i) => (
          <Alert key={`${a.code || 'alert'}-${i}`} severity={severityMap[a.severity] || 'info'} variant="outlined">
            {a.message}
          </Alert>
        ))}
      </Stack>
    </Paper>
  );
};

export default AlertsPanel;
